import React, { createContext, useCallback, useEffect, useState } from "react"
import { useDebouncedProperty } from "../../mp-core/hooks"

type SearchState = {
  search: string
  inputValue: string
  onSearch: (value: any) => void
}

export const SearchStateContext = createContext<SearchState>(null)

const MIN_SEARCH_LENGTH = 3

interface SearchStateProviderProps {
  resetKey?: string
  children: React.ReactNode
}

const SearchStateProvider: React.FC<SearchStateProviderProps> = ({
  resetKey,
  children
}) => {
  const [inputValue, setInputValue] = useState("")
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebouncedProperty(search, 300, "")

  const onSearch = useCallback(value => {
    const nextValue = value?.slice(0, 50) || ""
    const trimmedValue = nextValue.trim()

    setInputValue(nextValue)

    if (
      trimmedValue.length === 0 ||
      trimmedValue.length >= MIN_SEARCH_LENGTH
    ) {
      setSearch(trimmedValue)
    }
  }, [])

  // Reset search when resetKey changes
  useEffect(() => {
    if (resetKey) {
      setInputValue("")
      setSearch("")
    }
  }, [resetKey])

  return (
    <SearchStateContext.Provider
      value={{ search: debouncedSearch, inputValue, onSearch }}
    >
      {children}
    </SearchStateContext.Provider>
  )
}

export default SearchStateProvider
